export default __webpack_public_path__ + "static/music_thumbnail-694c66c2da03a604f59eebc725fba1a4.png";